import type { AnyAction } from 'redux';
// Import from subpath aliases: the bare 'constants' specifier resolves to Node's
// builtin `constants` module, whereas `constants/*` maps to ./src/constants/*.
import * as HeaderConstants from 'constants/header';
import * as CloudAdmin from 'constants/cloud-admin';
import * as ProductTab from 'constants/product-tab';
import * as SuperAdmin from 'constants/super-admin';

export interface HeaderState {
  filterKeyword: string;
}

const initialState: HeaderState = {
  filterKeyword: '',
};

const clearFilter = (state: HeaderState): HeaderState => ({ ...state, filterKeyword: '' });

export default function Header(state: HeaderState = initialState, action: AnyAction): HeaderState {
  switch (action.type) {
    case HeaderConstants.FILTER_KEYWORD.SET_FILTER_KEYWORD:
      return { ...state, filterKeyword: action.filterKeyword };
    case HeaderConstants.FILTER_KEYWORD.CLEAR_FILTER_KEYWORD:
      return clearFilter(state);

    // Clear filter keyword on these actions:
    case CloudAdmin.TOOL_SELECTOR_ACTION_TYPES.SELECT_TOOL_BUTTON:
      return clearFilter(state);
    case ProductTab.SELECTED_PRODUCT_TAB:
      return clearFilter(state);
    case SuperAdmin.SELECTOR_ACTION_TYPES.SELECT_TOOL:
      return clearFilter(state);

    default:
      return state;
  }
}
